import React from 'react';
import { PageHeader } from 'antd';
import { MyBreadcrumb } from 'utils';
import ClientsForm from './form';
export default function ClientsUpdate(props) {
    const { id } = props.match.params;
    return (
        <div>
            <MyBreadcrumb items={[{ label: "Client", path: "/clients" }, { label: "Update", path: "" }]} />
            <PageHeader
                ghost={false}
                onBack={() => window.history.back()}
                title="Update"
                subTitle=""
            >
                <ClientsForm id={id} />
            </PageHeader>
        </div>
    );
}